'use client'

import React, { FC, ReactElement } from 'react'
import styles from './CreateWalletTitle.module.css'
import classNames from 'classnames'
import { CREATE_WALLET_STEPS, RESTORE_WALLET_STEPS } from '../constants'

const CreateWalletTitle: FC<{ step: number; restore?: boolean }> = ({
	step,
	restore
}): ReactElement => {
	const stepData = React.useMemo(
		() => (restore ? RESTORE_WALLET_STEPS[step] : CREATE_WALLET_STEPS[step]),
		[restore, step]
	)

	return (
		<div className={styles.root}>
			<p className={classNames(styles.title, 'display-xs', 'semibold')}>{stepData.title}</p>
			<p className={classNames(styles.description, 'text-md', 'regular')}>{stepData.description}</p>
		</div>
	)
}

export default CreateWalletTitle
